import { useEffect, useState } from 'react'

export interface InstructorArtist {
  id: string
  name: string
  image_url: string | null
  play_count: number
}

export interface ThemeCount {
  name: string
  count: number
}

export interface ThemeSpotlight {
  theme: string
  ride_count: number
  top_artists: InstructorArtist[]
}

export interface InstructorDetail {
  instructor: {
    id: string
    name: string
    image_url: string | null
    short_bio: string | null
  }
  totals: {
    rides: number
    rides_detailed: number
    unique_songs: number
    unique_artists: number
    avg_songs_per_ride: number
  }
  concentration: {
    top_artist_share_percent: number
    top_5_share_percent: number
  }
  top_artists: InstructorArtist[]
  genres: ThemeCount[]
  themes: ThemeCount[]
  theme_spotlight: ThemeSpotlight | null
}

export function useInstructorStats(id: string | undefined) {
  const [data, setData] = useState<InstructorDetail | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) return

    let cancelled = false
    setData(null)
    setError(null)

    fetch(`/api/instructors/${id}`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.json() as Promise<InstructorDetail>
      })
      .then((json) => {
        if (!cancelled) setData(json)
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load instructor')
      })

    return () => {
      cancelled = true
    }
  }, [id])

  return { data, error }
}
